let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4CW7s")).then(() => parcelRequire('bVs9G'));